<template>
  <b-row>
    <b-col cols="12">
      <create-users-card />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import CreateUsersCard from './CreateUsersCard.vue'

export default {
  components: {
    BRow,
    BCol,

    CreateUsersCard,
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
